import React from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "../../../../../helpers/functions";
import MedicationSidebarList from "./MedicationSidebarList";
import { drugTypes } from "../../service-steps/clinical-assessment/data";
import { ClinicalServiceTypes } from "../../../text/data";

const PrescribedSection = ({
  filteredMedication,
  showPrescribedRxMeds,
  setShowPrescribedRxMeds,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  isIntervention,
  clinicalServiceName,
  prescribedRxEnabled,
}) => {
  if (isIntervention) return null;

  // Filter and combine medications based on context and prescribedRxEnabled state
  const prescribedRxMedications = filteredMedication?.filter(
    (x) => x.medicationType === drugTypes.PrescribedRx
  ) || [];
  
  const historyPrescribedRxMedications = filteredMedication?.filter(
    (x) => x.medicationType === drugTypes.HistoryPrescribedRx
  ) || [];

  // Determine which medications to show based on context and prescribedRxEnabled state
  let combinedMedications = [];
  
  if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
    // Case 1: Inside Allergic Rhinitis
    if (prescribedRxEnabled) {
      // Show both PrescribedRx and HistoryPrescribedRx
      combinedMedications = [...prescribedRxMedications, ...historyPrescribedRxMedications];
    } else {
      // Show only PrescribedRx (default behavior)
      combinedMedications = [...prescribedRxMedications];
    }
  } else {
    // Case 2: Outside Allergic Rhinitis
    // When prescribedRx section is shown (via prescribedRxEnabled), show both types
    combinedMedications = [...prescribedRxMedications, ...historyPrescribedRxMedications];
  }

  // Custom title with icon and tooltip
  const customTitle = (
    <div className="flex items-center">
      <span className="flex whitespace-nowrap text-base">Rx - Pending Dispense</span>
    </div>
  );

  return (
    <Tab.Group className="w-full h-full flex flex-col">
      <Tab.Panels className="w-full flex-1 flex flex-col">
        <Tab.Panel
          className={classNames(
            "rounded-xl bg-white w-full flex-1 flex flex-col",
            "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2"
          )}
        >
          <MedicationSidebarList
            medications={combinedMedications}
            title={customTitle}
            isExpanded={showPrescribedRxMeds}
            onToggleExpanded={() => setShowPrescribedRxMeds(!showPrescribedRxMeds)}
            onMedicationClick={onMedicationClick}
            onMenuAction={onMenuAction}
            onExpandMedication={onExpandMedication}
            expandedMedications={expandedMedications}
            hoveredMed={hoveredMed}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            menuMedication={menuMedication}
            onMenuOpen={onMenuOpen}
            showMenu={showMenu}
            menuData={menuData}
            selectedMedication={selectedMedication}
            isMatchingDrug={isMatchingDrug}
            medicationDetails={medicationDetails}
            getNoRecordMessage={getNoRecordMessage}
            drugType={drugTypes.PrescribedRx}
            isIntervention={isIntervention}
          />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default PrescribedSection;
